import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import DOMPurify from 'dompurify';
import { Button, Checkbox, Icon, Expandable, Haldor__Block, addBlockTranslations } from '@haldor/ui';
import NDLAFrame from './NDLAFrame';
import './_NdlaBlock.scss';

var NDLABlock = /*#__PURE__*/function (_Haldor__Block) {
  _inherits(NDLABlock, _Haldor__Block);

  var _super = _createSuper(NDLABlock);

  function NDLABlock(_props) {
    var _this;

    _classCallCheck(this, NDLABlock);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "toggleModal", function (event) {
      if (event != null && event.preventDefault != null) {
        event.stopPropagation();
        event.preventDefault();
      }

      var showModal = _this.getResources().find(function (resource) {
        return resource['@odata.type'] == 'Haldor.Blocks.NDLA.ShowModal';
      });

      if (showModal != null) {
        _this.removeResource(showModal);

        return true;
      }

      _this.addResource('Haldor.Blocks.NDLA.ShowModal', {
        visible: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleDisplayType", function () {
      var containsIframeResource = _this.getResources().find(function (resource) {
        return resource['@odata.type'] == 'Haldor.Blocks.NDLA.displayType' && resource.value == 'iframe';
      });

      if (containsIframeResource != null) {
        _this.removeResource(containsIframeResource);
      } else {
        _this.addResource('Haldor.Blocks.NDLA.displayType', {
          value: 'iframe'
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onResourceSubmit", function (values) {
      _this.addResource('Haldor.Blocks.NDLA.article', values);
    });

    _defineProperty(_assertThisInitialized(_this), "renderResourceCard", function (resource) {
      var link = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (resource['@odata.type'] != 'Haldor.Blocks.NDLA.article') {
        return null;
      }

      var Elem = function Elem(props) {
        return link ? /*#__PURE__*/React.createElement("a", props) : /*#__PURE__*/React.createElement("div", props);
      };

      return /*#__PURE__*/React.createElement("div", {
        className: "ndla-resource-container",
        key: resource.id
      }, /*#__PURE__*/React.createElement(Elem, {
        className: "ndla-resource",
        href: resource.url,
        target: "_blank"
      }, /*#__PURE__*/React.createElement("div", {
        className: "resource-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "image",
        style: {
          backgroundImage: "url(".concat(resource.metaImageUrl, "?width=325)")
        },
        title: resource.metaImageAlt
      }), /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "title df aic"
      }, /*#__PURE__*/React.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: DOMPurify.sanitize(resource.title)
        },
        style: {
          marginRight: '.35rem'
        }
      }), /*#__PURE__*/React.createElement(Icon, {
        name: "External"
      })), /*#__PURE__*/React.createElement("div", {
        className: "description",
        dangerouslySetInnerHTML: {
          __html: DOMPurify.sanitize(resource.introduction)
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "resource-footer"
      }, /*#__PURE__*/React.createElement("div", {
        className: "url"
      }), /*#__PURE__*/React.createElement("span", {
        className: "delete-resource",
        onClick: function onClick() {
          return _this.removeResource(resource);
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Bin"
      })))));
    });

    _defineProperty(_assertThisInitialized(_this), "edit", function (props) {
      var translate = _this.api.getEditor().getProp('translate');

      var showModal = props.resources.find(function (resource) {
        return resource['@odata.type'] == 'Haldor.Blocks.NDLA.ShowModal';
      });
      var containsIframeResource = props.resources.find(function (resource) {
        return resource['@odata.type'] == 'Haldor.Blocks.NDLA.displayType' && resource.value == 'iframe';
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "block--ndla-block"
      }, showModal != null ? /*#__PURE__*/React.createElement(NDLAFrame, {
        toggleModal: _this.toggleModal,
        onSubmit: _this.onResourceSubmit
      }) : null, /*#__PURE__*/React.createElement("div", {
        className: "ndla-resource-list"
      }, props.resources.map(function (resource) {
        return _this.renderResourceCard(resource);
      })), /*#__PURE__*/React.createElement("div", {
        className: "df aic jcb"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: _this.toggleModal
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Plus"
      }), translate('Add resource')), /*#__PURE__*/React.createElement(Checkbox, {
        label: translate('Embed content'),
        value: containsIframeResource != null,
        onChange: _this.toggleDisplayType
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "consume", function (props) {
      var containsIframeResource = props.resources.find(function (resource) {
        return resource['@odata.type'] == 'Haldor.Blocks.NDLA.displayType' && resource.value == 'iframe';
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "block--ndla-block"
      }, /*#__PURE__*/React.createElement("div", {
        className: "ndla-resource-list"
      }, props.resources.map(function (resource) {
        if (resource['@odata.type'] != 'Haldor.Blocks.NDLA.article') {
          return null;
        }

        if (containsIframeResource != null) {
          return /*#__PURE__*/React.createElement(Expandable, {
            title: resource.title
          }, /*#__PURE__*/React.createElement("iframe", {
            key: resource.id,
            src: resource.url,
            height: 1000
          }));
        }

        return _this.renderResourceCard(resource, true);
      })));
    });

    _this.name = 'Haldor.Blocks.NDLA';
    _this.order = 48;

    _this.icon = function () {
      return /*#__PURE__*/React.createElement("svg", {
        xmlns: "http://www.w2.org/2000/svg",
        viewBox: "0 0 50 50",
        dangerouslySetInnerHTML: {
          __html: "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 50 50\" style=\"enable-background:new 0 0 50 50;\" xml:space=\"preserve\">\n\t\t\t\t\t\t<style type=\"text/css\">\n\t\t\t\t\t\t\t.st0{fill:#C8C9C8;}\n\t\t\t\t\t\t</style>\n\t\t\t\t\t\t<g>\n\t\t\t\t\t\t\t<path class=\"st0\" d=\"M29.2,15.1c0,0.1,0,0.1,0,0.2c0,5.1,0,10.2,0,15.3v0.2H16.7V19.6H27v-4.5H29.2z M27,22h-8.2v6.5H27L27,22z\"/>\n\t\t\t\t\t\t\t<path class=\"st0\" d=\"M47.9,30.9c-0.1,0-0.1,0-0.1,0H35.5v-6.7h10.4V22H35.5v-2.4h10.4V22h2L47.9,30.9z M45.8,28.5v-2.6h-8.3v2.6\n\t\t\t\t\t\t\t\tH45.8z\"/>\n\t\t\t\t\t\t\t<path class=\"st0\" d=\"M2.1,19.6c0.1,0,0.1,0,0.1,0h12.3v11.2h-2.1V22H4.3v8.9H2.1V19.6z\"/>\n\t\t\t\t\t\t\t<path class=\"st0\" d=\"M33.3,15.1c0,0.1,0,0.1,0,0.2c0,5.1,0,10.2,0,15.3v0.2h-2.1v-0.2c0-5.1,0-10.2,0-15.3c0-0.1,0-0.1,0-0.2H33.3z\"/>\n\t\t\t\t\t\t</g>\n\t\t\t\t\t</svg>"
        }
      });
    };

    addBlockTranslations('sv-se', [{
      output: 'NDLA',
      id: 'Haldor.Blocks.NDLA'
    }]);
    addBlockTranslations('en-us', [{
      output: 'NDLA',
      id: 'Haldor.Blocks.NDLA'
    }]);
    addBlockTranslations('nb-no', [{
      output: 'NDLA',
      id: 'Haldor.Blocks.NDLA'
    }]);
    addBlockTranslations('da-dk', [{
      output: 'NDLA',
      id: 'Haldor.Blocks.NDLA'
    }]);
    addBlockTranslations('uk', [{
      output: 'NDLA',
      id: 'Haldor.Blocks.NDLA'
    }]);

    _this.registerResourceType('Haldor.Blocks.NDLA.article', {
      articleType: 'string',
      id: 'number',
      introduction: 'string',
      metaImageAlt: 'string',
      metaImageUrl: 'string',
      revision: 'number',
      revisionDate: 'string',
      title: 'string',
      updated: 'string',
      url: 'string'
    });

    _this.registerResourceType('Haldor.Blocks.NDLA.displayType', {
      value: 'string'
    });

    _this.registerResourceType('Haldor.Blocks.NDLA.ShowModal', {
      visible: 'boolean'
    });

    return _this;
  }

  return _createClass(NDLABlock);
}(Haldor__Block);

export default NDLABlock;